module.exports = __webpack_public_path__ + "static/financialHealthNetwork-727d1682602f341b091e863486bd9bfd.png";